module.exports = __webpack_public_path__ + "assets/img/cpnews35.245eeea8.jpg";